import { createGlobalStyle } from 'styled-components';
const GlobalStyle = createGlobalStyle `
  #app {
    height: calc(var(--vh, 1vh) * 100);
    display: flex;
    flex-direction: column;
  }
`;
export default GlobalStyle;
